"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.COMMAND_DynaNodeMasterServiceMessageRegisterWorker = "COMMAND_DynaNodeMasterServiceMessageRegisterWorker";
exports.COMMAND_DynaNodeMasterServiceMessageHeartbeat = "COMMAND_DynaNodeMasterServiceMessageHeartbeat";
exports.COMMAND_DynaNodeWorkerServicePing = 'COMMAND_DynaNodeWorkerServicePing';
exports.COMMAND_DynaNodeWorkerServiceWorkerWrappedMessage = 'COMMAND_DynaNodeWorkerServiceWorkerWrappedMessage';
exports.COMMAND_DynaNodeWorkerServiceYouAreDead = 'COMMAND_DynaNodeWorkerServiceYouAreDead';
//# sourceMappingURL=interfacesMasterWorker.js.map